/** «Einstellungen» on Ich (docs/UX.md §1, §2). */
export const settings = {
  title: "Einstellungen",
  deviceHint: "Gilt für dieses Gerät.",
  textSize: "Schriftgrösse",
  textSizes: { normal: "Normal", large: "Gross", xlarge: "Sehr gross" },
  readableFont: "Leserfreundliche Schrift",
  readableFontHint: "Buchstaben, die man kaum verwechseln kann.",
  speech: "Vorlesen",
  autoSpeak: "Automatisch vorlesen",
  /**
   * True for both directions: a card asked in German reads the solution once
   * it is shown, not the German question (#98).
   */
  autoSpeakHint: "Liest jedes englische oder französische Wort vor, sobald es auf dem Bildschirm steht.",
  /** Only the screen reader hears this label; one verb for one thing (#98). */
  rate: "Tempo beim Vorlesen",
  rates: { normal: "Normal", slow: "Langsam" },
  tryVoice: (lang: string) => `${lang} vorlesen`,
  /** Sample words: short, the same in every class, nothing to translate. */
  sample: { en: "Good morning", fr: "Bonjour" },
  noVoice: (lang: string) => `Auf diesem Gerät fehlt eine Stimme für ${lang}.`,
  /**
   * A page cannot see the iOS mute switch or the volume (#74), so the hint
   * cannot depend on the sound. It shows once a sample was tapped and asks
   * about that tap, so it does not read like an error (#98).
   */
  noSound: "Nichts gehört? Schau, ob dein Gerät lautlos oder ganz leise gestellt ist.",
  noSpeech: "Dieser Browser kann nicht vorlesen.",
} as const;
